import React from 'react';
import { PriceCard } from './Shared';
export const PriceSection = () => {
  return <section id="precio" className="bg-familia-section py-10 md:py-16 px-4 md:px-6" data-id="element-176">
      <div className="max-w-7xl mx-auto" data-id="element-177">
        <PriceCard data-id="element-178" />
      </div>
    </section>;
};